/**
 * @generated SignedSource<<6cd7e2785dc6c9837488d05f7293352e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AppDocusign_viewer$data = {
  readonly id: string;
  readonly company: {
    readonly id: string;
    readonly docusignEnabled: boolean | null;
  } | null;
  readonly " $fragmentType": "AppDocusign_viewer";
};
export type AppDocusign_viewer$key = {
  readonly " $data"?: AppDocusign_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"AppDocusign_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AppDocusign_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "docusignEnabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "21ed6820f0e3877368c187d95e2dd5a0";

export default node;
